/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { DialogRef } from '@angular/cdk/dialog';
import { Component, inject, Input } from '@angular/core';
import { ButtonComponent, TooltipDirective } from '@ods/system';

@Component({
  selector: 'odc-cancel-dialog-button',
  imports: [ButtonComponent, TooltipDirective],
  template: ` @if (showAsIconButton) {
      <ods-button
        (clicked)="cancel()"
        [tooltip]="'Schließen'"
        tooltipAriaType="aria-label"
        variant="ghost"
        size="fit"
        icon="close"
        dataTestId="cancel-dialog-icon-button"
        data-test-id="cancel-dialog-icon-button-container"
      />
    } @else {
      <ods-button
        (clicked)="cancel()"
        variant="outline"
        text="Abbrechen"
        icon="close"
        dataTestId="cancel-dialog-button"
        data-test-id="cancel-dialog-button-container"
      />
    }`,
})
export class CancelDialogButtonComponent {
  private readonly dialogRef = inject(DialogRef);

  @Input() showAsIconButton: boolean = false;
  @Input() closeResultData: any;

  public cancel(): void {
    this.dialogRef.close(this.closeResultData);
  }
}
